import { Clock3, ShieldCheck, CreditCard, Building2 } from "lucide-react";
import { Reveal, SectionTag } from "./Reveal";
import { IMAGES } from "../lib/site";
import { useContent } from "../lib/content";

const cardCls =
    "relative rounded-[1.75rem] p-7 sm:p-9 h-full sticker-soft hover:sticker transition-shadow duration-300 overflow-hidden";

export default function Beneficios() {
    const t = useContent().beneficios;
    return (
        <section id="beneficios" className="scroll-mt-24 bg-[#F7F4EC] py-20 sm:py-28">
            <div className="mx-auto max-w-7xl px-4 sm:px-6">
                <Reveal className="max-w-2xl">
                    <SectionTag tone="green">Os 4 pilares</SectionTag>
                    <h2 className="mt-5 text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-[#1A231E]">
                        {t.title1}
                        <span className="text-[#F57A3A]">{t.title2}</span>
                    </h2>
                    <p className="mt-4 text-base sm:text-lg text-[#1A231E]/70 leading-relaxed">
                        {t.subtitle}
                    </p>
                </Reveal>

                <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-6 gap-5">
                    <Reveal className="lg:col-span-4">
                        <div className={`${cardCls} bg-[#0E6B3F] text-[#F7F4EC]`} data-testid="bento-benefit-24h">
                            <Clock3 className="w-10 h-10 text-[#F1C75B]" strokeWidth={2.2} />
                            <h3 className="mt-5 text-2xl sm:text-3xl font-extrabold">{t.b1.t}</h3>
                            <p className="mt-3 text-base text-[#F7F4EC]/85 leading-relaxed max-w-md">
                                {t.b1.d}
                            </p>
                            <span className="font-caveat text-3xl text-[#F1C75B] inline-block mt-4 -rotate-2">
                                {t.note1}
                            </span>
                            <img
                                src={IMAGES.interiorGondolas}
                                alt="Interior da loja Conbox com gôndonas abastecidas"
                                className="absolute -right-6 -bottom-8 w-44 sm:w-56 rounded-2xl border-2 border-[#F7F4EC]/30 rotate-3 object-cover hidden sm:block"
                            />
                        </div>
                    </Reveal>

                    <Reveal delay={0.08} className="lg:col-span-2">
                        <div className={`${cardCls} bg-[#F1C75B] text-[#1A231E]`} data-testid="bento-benefit-security">
                            <ShieldCheck className="w-10 h-10 text-[#0E6B3F]" strokeWidth={2.2} />
                            <h3 className="mt-5 text-2xl font-extrabold">{t.b2.t}</h3>
                            <p className="mt-3 text-base text-[#1A231E]/80 leading-relaxed">
                                {t.b2.d}
                            </p>
                        </div>
                    </Reveal>

                    <Reveal delay={0.05} className="lg:col-span-2">
                        <div className={`${cardCls} bg-[#EFEAE0] text-[#1A231E]`} data-testid="bento-benefit-practicality">
                            <CreditCard className="w-10 h-10 text-[#F57A3A]" strokeWidth={2.2} />
                            <h3 className="mt-5 text-2xl font-extrabold">{t.b3.t}</h3>
                            <p className="mt-3 text-base text-[#1A231E]/80 leading-relaxed">
                                {t.b3.d}
                            </p>
                        </div>
                    </Reveal>

                    <Reveal delay={0.12} className="lg:col-span-4">
                        <div className={`${cardCls} bg-[#F57A3A] text-[#F7F4EC]`} data-testid="bento-benefit-location">
                            <Building2 className="w-10 h-10 text-[#F1C75B]" strokeWidth={2.2} />
                            <h3 className="mt-5 text-2xl sm:text-3xl font-extrabold">{t.b4.t}</h3>
                            <p className="mt-3 text-base text-[#F7F4EC]/90 leading-relaxed max-w-md">
                                {t.b4.d}
                            </p>
                            <span className="font-caveat text-3xl text-[#1A231E] inline-block mt-4 rotate-1">
                                {t.note2}
                            </span>
                        </div>
                    </Reveal>
                </div>
            </div>
        </section>
    );
}
